import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DocumentAccessLogsApiService } from '../../api/documents/document-access-logs-api.service';
import {
  LogDocumentAccessDto,
  DocumentAccessLogResponseDto,
  AccessStatsResponseDto,
  LogAccessResponseDto,
} from '../../../api/models';
import { AccessLogQueryDto, AccessLogStatsQueryDto, AuditTrailQueryDto } from '../../../interfaces/documents';

@Injectable({ providedIn: 'root' })
export class CachedDocumentAccessLogsService extends DocumentAccessLogsApiService {
  
  // ========== PUBLIC API ==========

  /**
   * Log document view access
   */
  public logView$(documentId: string, logData?: Partial<LogDocumentAccessDto>): Observable<LogAccessResponseDto> {
    return super._logView$(documentId, logData);
  }

  /**
   * Log document download access
   */
  public logDownloadAccess$(documentId: string, logData?: Partial<LogDocumentAccessDto>): Observable<LogAccessResponseDto> {
    return super._logDownloadAccess$(documentId, logData);
  }

  /**
   * Get access logs for a specific document
   */
  public getDocumentLogs$(documentId: string, query?: AccessLogQueryDto): Observable<DocumentAccessLogResponseDto[]> {
    return super._getDocumentLogs$(documentId, query);
  }

  /**
   * Get access logs for a specific patient
   */
  public getPatientLogs$(patientId: string, query?: AccessLogQueryDto): Observable<DocumentAccessLogResponseDto[]> {
    return super._getPatientLogs$(patientId, query);
  }

  /**
   * Get access logs for a specific user
   */
  public getUserLogs$(userId: string, query?: AccessLogQueryDto): Observable<DocumentAccessLogResponseDto[]> {
    return super._getUserLogs$(userId, query);
  }

  /**
   * Get access logs for a specific user role
   */
  public getUserRoleLogs$(userRole: string, query?: AccessLogQueryDto): Observable<DocumentAccessLogResponseDto[]> {
    return super._getUserRoleLogs$(userRole, query);
  }

  /**
   * Get recent access logs
   */
  public getRecentLogs$(query?: AccessLogQueryDto): Observable<DocumentAccessLogResponseDto[]> {
    return super._getRecentLogs$(query);
  }

  /**
   * Get access statistics
   */
  public getAccessStats$(query?: AccessLogStatsQueryDto): Observable<AccessStatsResponseDto> {
    return super._getAccessStats$(query);
  }

  /**
   * Get audit trail for compliance
   */
  public getAuditTrail$(query: AuditTrailQueryDto): Observable<DocumentAccessLogResponseDto[]> {
    return super._getAuditTrail$(query);
  }
}